import { type ColorSource, TextStyle } from "pixi.js"
import type { NodeLabel } from "../types/Graph"

// Define the text style for customer names
export const nodeTextStyle = new TextStyle({
  fill: 0x000000,
  fontSize: 14,
  fontFamily: getComputedStyle(document.documentElement).getPropertyValue("--fr-body-font-family").trim()
})

export const badgeFontStyle = new TextStyle({
  fontSize: 10,
  fontVariant: "small-caps",
  fontFamily: getComputedStyle(document.documentElement).getPropertyValue("--fr-body-font-family").trim(),
  fill: 0x000000
})

export const GRAPH_CONTAINER_NAME = "graphContainer"

export const PADDING_X = 24
export const PADDING_Y = 10
export const NODE_WIDTH = 200
export const NODE_HEIGHT = 37
export const NODE_BORDER_RADIUS = 20
export const LENGTH_BETWEEN_NODE_LAYERS = 40
export const EDGE_SEGMENT_VERTICAL_LENGTH = LENGTH_BETWEEN_NODE_LAYERS / 2
export const NODE_ANIMATION_DURATION = 400

export const BADGE_PADDING_X = 6
export const BADGE_PADDING_Y = 4

export const HIGHLIGHT_NODE_COLOR = 0x76c7b2
const DEFAULT_NODE_COLOR = 0xe9f0f4
const BILLING_ENTITY_NODE_COLOR = 0xf8bbd9
export const EDGE_COLOR = 0x000000
export const BADGE_BG_COLOR = 0xf0f2f2
export const BADGE_BORDER_COLOR = 0xffffff

export const NODE_LABELS = {
  CUSTOMER: "customer",
  PLAN_CUSTOMER: "planCustomer",
  INSTANCE: "instance",
  SERVER: "server",
  APPLICATION: "application",
  BILLING_ENTITY: "billingEntity"
} as const

export const ALLOWED_LABELS = ["customer", "planCustomer", "instance", "server", "application"] as const

export const LABEL_BG_COLOR_MAP: Record<NodeLabel, ColorSource> = {
  [NODE_LABELS.CUSTOMER]: DEFAULT_NODE_COLOR,
  [NODE_LABELS.PLAN_CUSTOMER]: 0xffd700,
  [NODE_LABELS.INSTANCE]: 0x90caf9,
  [NODE_LABELS.SERVER]: 0xce93d8,
  [NODE_LABELS.APPLICATION]: 0xffab91,
  [NODE_LABELS.BILLING_ENTITY]: BILLING_ENTITY_NODE_COLOR
}

const LABEL_BORDER_COLOR_MAP: Record<NodeLabel, ColorSource> = {
  [NODE_LABELS.CUSTOMER]: 0xd6e1e9,
  [NODE_LABELS.PLAN_CUSTOMER]: 0xdab900,
  [NODE_LABELS.INSTANCE]: 0x64a7e6,
  [NODE_LABELS.SERVER]: 0xb164c0,
  [NODE_LABELS.APPLICATION]: 0xff8a65,
  [NODE_LABELS.BILLING_ENTITY]: 0xf48fb1
}

export function getBorderColor(label: NodeLabel, isCurrentNode: boolean, isRootCustomer = false) {
  if (isCurrentNode) {
    return LABEL_BORDER_COLOR_MAP[label]
  }

  if (isRootCustomer) {
    return HIGHLIGHT_NODE_COLOR
  }

  return LABEL_BG_COLOR_MAP[label]
}

// Icon colors for NodeIconTooltip
export const ICON_COLORS = {
  DEFAULT: "#061213",
  PRIMARY: "#087c61",
  SECONDARY: "#fafbfb"
} as const

// Inactive icon colors
export const INACTIVE_ICON_COLORS = {
  color: "#949ea0", // --fr-neutral-400
  primaryColor: "#949ea0", // --fr-neutral-400
  secondaryColor: "#fafbfb" // --fr-neutral-15
} as const

export const ICON_RESOLUTION_MULTIPLIER = 3
export const ICON_RENDER_TIMEOUT = 50
